import React from 'react';
import { useParams } from 'react-router-dom';
import { getUniverseBySlug } from '../data/unifiedEcosystem';
import { ExternalLink, Radio } from 'lucide-react';

export const UniverseDetailPage = () => {
  const { slug } = useParams();
  const universe = getUniverseBySlug(slug);

  if (!universe) {
    return (
      <div className="editorial-container py-32 text-center">
        <p className="text-muted-foreground text-sm uppercase tracking-widest">Universe not found</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      {/* Transmission Header */}
      <section className="editorial-container py-12 border-b border-border">
        <div className="font-mono text-xs text-primary space-y-1">
          <p>// TRANSMISSION //</p>
          <p>SIGNAL LOCKED: HUMAN FREQUENCY IDENTIFIED</p>
          <p>STATUS: {universe.status.toUpperCase()}</p>
          <p>PERMISSION: GRANTED</p>
        </div>
      </section>

      {/* Hero */}
      <section className="editorial-container py-20 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24">
          <div className="relative aspect-square bg-black border border-primary/20">
            <img
              src={universe.image}
              alt={universe.title}
              className="w-full h-full object-cover opacity-80"
            />
            <div className="absolute inset-0 bg-primary/5"></div>
          </div>

          <div className="flex flex-col justify-center space-y-8">
            <div className="flex items-center gap-3">
              <Radio size={16} className="accent-red animate-pulse" />
              <span className="text-xs font-bold uppercase tracking-widest accent-red">
                {universe.status}
              </span>
            </div>
            
            <h1 className="text-5xl sm:text-6xl lg:text-7xl editorial-serif leading-none">
              {universe.title}
            </h1>
            
            <p className="text-xl text-foreground/80 leading-relaxed">
              {universe.tagline}
            </p>

            <p className="text-base text-foreground/70 leading-relaxed">
              {universe.description}
            </p>

            <div className="text-sm text-muted-foreground uppercase tracking-wider">
              {universe.company}
            </div>
          </div>
        </div>
      </section>

      {/* World Building */}
      {universe.worldBuilding && (
        <section className="editorial-container py-16 border-t border-border">
          <div className="editorial-narrow space-y-12">
            <div>
              <h2 className="text-2xl editorial-serif mb-6">Transmission</h2>
              <p className="text-lg leading-relaxed text-foreground/80 font-mono">
                {universe.worldBuilding.premise}
              </p>
            </div>

            <div className="border-l-2 border-primary pl-8">
              <p className="text-lg editorial-serif leading-relaxed">
                {universe.worldBuilding.mythology}
              </p>
            </div>
          </div>
        </section>
      )}

      {/* Platform */}
      {universe.platform && (
        <section className="editorial-container py-16 border-t border-border">
          <div className="text-center space-y-8">
            <h2 className="text-2xl editorial-serif">Enter The Universe</h2>
            <p className="text-lg text-foreground/80 max-w-2xl mx-auto">
              {universe.platform.description}
            </p>
            <a
              href={universe.platform.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 bg-primary text-primary-foreground text-sm uppercase tracking-widest hover:bg-primary/90"
            >
              <Radio size={16} />
              Initiate Entry
              <ExternalLink size={14} />
            </a>
          </div>
        </section>
      )}

      {/* Footer Transmission */}
      <section className="editorial-container py-12 border-t border-border">
        <div className="font-mono text-xs text-muted-foreground text-center space-y-1">
          <p>THE PORTAL IS OPEN</p>
          <p>THE TRUTH IS OUT</p>
          <p>JOIN US BEFORE THE MESSAGE FADES</p>
        </div>
      </section>
    </div>
  );
};

export default UniverseDetailPage;
